import ReactDOM from "react-dom";
import React from "react";
import NotificationToast from "../components/common/NotificationToast";

/**
 * Shows a toast notification when an item is added to a list
 * @param options Configuration for the toast notification
 */
export const showListSaveToast = (options: { 
  itemName?: string; 
  listName?: string;
  isError?: boolean; 
  errorMessage?: string;
}) => {
  const { itemName = '', listName = '', isError = false, errorMessage } = options;
  
  // Create a div to render the toast into if it doesn't exist
  let toastContainer = document.getElementById('list-save-toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'list-save-toast-container';
    document.body.appendChild(toastContainer);
  }

  // Render the toast into the container
  ReactDOM.render(
    React.createElement(NotificationToast, { 
      itemName, 
      listName,
      isError, 
      errorMessage,
      type: 'listSave'
    }),
    toastContainer
  );

  // Remove the toast after it's done (5 seconds)
  setTimeout(() => {
    if (toastContainer && document.body.contains(toastContainer)) {
      ReactDOM.unmountComponentAtNode(toastContainer);
    }
  }, 5000);
};
